import { useOidcAuthentication } from '@cp-shared-10/frontend-ui';
import { useTranslation } from 'react-i18next';
import { dashboardPagePath } from '../components/navigation/paths';

export function useLogin(pathFn: () => string = dashboardPagePath): () => Promise<void> {
    const { login } = useOidcAuthentication();
    const { i18n } = useTranslation();
    const locale = i18n.languages[0];

    return (): Promise<void> =>
        login({
            redirect_uri: window.location.origin + pathFn(),
            redirectTarget: 'self',
            redirectMethod: 'assign',
            ui_locales: locale,
        });
}
